import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'tinymce';

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  folderDeletedSubject = new Subject<string>();
  closeDialogSubject = new Subject<boolean>();

  closeDialog$ = this.closeDialogSubject.asObservable();
  folderUpdated$ = this.folderDeletedSubject.asObservable();
  

  notifyFolderUpdated(data: any): any {
    this.folderDeletedSubject.next(data);
  }
  closeDialog(): void {
    this.closeDialogSubject.next(true);
  }
}
